import { useState } from "react";
import styled from "styled-components";
import { useAppSelector } from "../app/hooks";
import { userState } from "../app/reducers/user-slice";
import { UserFormDialog } from "../components/dialog/UserFormDialog";
import { UserTabPanel } from "../components/tab-panel/UserTabPanel";
import { GeneralTab } from "../components/tab/GeneralTab";
import { useGetUserByIdQuery } from "../query/user-query";
import { Role } from "../types/user/role";
import useDidMountEffect from "../utils/custom-hook/use-did-mount-effect";
import { ContainedGrayButton } from "../components/button/ContainedGrayButton";

const tabMap: { [key: string]: Role } = {
  "배송프로": Role.Pro,
  "관리자": Role.Admin,
};

export const UserView = () => {
  const { selectedUser } = useAppSelector(userState);
  const [tab, setTab] = useState({
    index: 0,
    key: Object.keys(tabMap)[0],
  });
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [payload, setPayload] = useState<string>("");
  useGetUserByIdQuery(payload);

  const handleClickDialogOpen = () => {
    setDialogOpen(true);
  };

  const handleClickDialogClose = () => {
    setDialogOpen(false);
  };

  const handleClickTab = (key: string, index: number) => {
    setTab({
      key,
      index,
    });
  };

  useDidMountEffect(() => {
    if (selectedUser) {
      handleClickDialogOpen();
    } else {
      handleClickDialogClose();
    }
  }, [selectedUser]);

  return (
    <UserViewContainer>
      <UserViewTitle>
        <GeneralTab tabMap={tabMap} tab={tab} onClickTab={handleClickTab} />
      </UserViewTitle>
      <UserViewContent>
        <UserTabPanel
          role={tabMap[tab.key]}
          handleClickDialogOpen={handleClickDialogOpen}
          handleClickDialogClose={handleClickDialogClose}
        />
      </UserViewContent>
      {dialogOpen && (
        <UserFormDialog
          role={tabMap[tab.key]}
          setPayload={setPayload}
          handleClickDialogClose={handleClickDialogClose}
        />
      )}
    </UserViewContainer>
  );
};

const UserViewContainer = styled.div`
  width: 100%;
`;

const UserViewTitle = styled.div`
  display: flex;
  padding: 1.5rem 4rem;
`;

const UserViewContent = styled.div`
  width: 61%;
  margin: 0 auto;
`;
